
    export const getCurrentLanguage = () => {
        let lang ;
        if(localStorage.getItem('i18nextLng')){
            lang= localStorage.getItem('i18nextLng');
        }else{
            lang= document.querySelector('html').lang;
        }

        return lang;
    }